import React from 'react';
import { Typography, Box } from '@mui/material';
import { styled } from '@mui/system';

const Section = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(3),
}));

const Paragraph = styled(Typography)(({ theme }) => ({
  fontFamily: 'Playfair Display, serif',
  fontSize: '1.1rem',
  lineHeight: 1.6,
  textAlign: 'left',
  '@media (max-width: 400px)': {
    fontSize: '1rem',
  },
  '@media (max-width: 320px)': {
    fontSize: '0.95rem',
  },
}));

const Heading = styled(Typography)(({ theme }) => ({
  fontFamily: 'Playfair Display, serif',
  fontSize: '1.3rem',
  color: '#ffbfe5',
  marginBottom: theme.spacing(1),
  textShadow: '0 2px 4px rgba(0, 0, 0, 0.5)',
}));

const PrivacyPolicyContent = () => {
  return (
    <Box>
      <Section>
        <Heading>Privacy Policy for Deeper</Heading>
        <Paragraph>Effective Date: [Insert Date]</Paragraph>
      </Section>

      <Section>
        <Heading>1. Introduction</Heading>
        <Paragraph>
          This Privacy Policy explains how Deeper (“we,” “us,” or “our”) collects, uses, stores, and shares your information when you use the App.
        </Paragraph>
        <Paragraph>
          By using the App, you agree to the practices described in this Privacy Policy.
        </Paragraph>
      </Section>

      <Section>
        <Heading>2. What Information We May Collect</Heading>
        <Paragraph>We may collect the following types of information, depending on how you use the App:</Paragraph>
        <Paragraph>
          <strong>Basic Identifiers:</strong> Email address, age confirmation, or user name (if provided)
        </Paragraph>
        <Paragraph>
          <strong>Device Information:</strong> Device type, operating system, browser type, language, country, IP address
        </Paragraph>
        <Paragraph>
          <strong>Usage Data:</strong> Interactions with features, screens visited, actions taken, crash reports
        </Paragraph>
        <Paragraph>
          <strong>Analytics Data:</strong> General activity data for performance and usage analysis
        </Paragraph>
        <Paragraph>
          <strong>Location Data:</strong> Approximate location based on IP or device settings (if permitted)
        </Paragraph>
        <Paragraph>
          <strong>Voluntary Submissions:</strong> Feedback, contact forms, or optional survey responses
        </Paragraph>
        <Paragraph>
          <strong>Payment & Donation Info:</strong> When donating via PayPal or other platforms, we may receive your name, email, and donation amount (but we do not store full payment details like credit card numbers)
        </Paragraph>
      </Section>

      <Section>
        <Heading>3. How We Use Your Information</Heading>
        <Paragraph>We may use your information to:</Paragraph>
        <Paragraph>• Provide and improve the App</Paragraph>
        <Paragraph>• Analyze usage and performance</Paragraph>
        <Paragraph>• Fix bugs or technical issues</Paragraph>
        <Paragraph>• Respond to inquiries or support requests</Paragraph>
        <Paragraph>• Comply with legal obligations</Paragraph>
        <Paragraph>• Protect against abuse, fraud, or violations of our Terms of Use</Paragraph>
      </Section>

      <Section>
        <Heading>4. How We Store and Protect Data</Heading>
        <Paragraph>
          Data may be stored on secure servers hosted by third-party providers. We use industry-standard security measures, but no method of transmission is 100% secure.
        </Paragraph>
        <Paragraph>
          If we collect identifiable data, it will be stored with appropriate safeguards under Israeli law and, if relevant, GDPR standards.
        </Paragraph>
      </Section>

      <Section>
        <Heading>5. Sharing of Data</Heading>
        <Paragraph>We do not sell your personal information. We may share data with:</Paragraph>
        <Paragraph>• Trusted third-party service providers (e.g., analytics, payment processors)</Paragraph>
        <Paragraph>• Legal authorities if required by law or to protect rights and safety</Paragraph>
        <Paragraph>• Partners or contractors working directly on App improvements (under strict confidentiality agreements)</Paragraph>
      </Section>

      <Section>
        <Heading>6. Cookies & Tracking</Heading>
        <Paragraph>
          We may use cookies or similar technologies for analytics and usage tracking. You can opt out or disable cookies via your device settings.
        </Paragraph>
      </Section>

      <Section>
        <Heading>7. Children's Privacy</Heading>
        <Paragraph>
          The App is intended for users 18 years or older. We do not knowingly collect data from minors. If we become aware that a user is under 18, we will delete their information.
        </Paragraph>
      </Section>

      <Section>
        <Heading>8. Your Choices & Rights</Heading>
        <Paragraph>Depending on your location and applicable laws, you may have rights to:</Paragraph>
        <Paragraph>• Access, correct, or delete your data</Paragraph>
        <Paragraph>• Request a copy of data we’ve collected</Paragraph>
        <Paragraph>• Withdraw consent to processing (where applicable)</Paragraph>
        <Paragraph>To exercise these rights, contact us at: deeper@deepergm.com</Paragraph>
      </Section>

      <Section>
        <Heading>9. Data Retention</Heading>
        <Paragraph>
          We retain data only as long as necessary for the purposes outlined above or as required by law.
        </Paragraph>
      </Section>

      <Section>
        <Heading>10. Updates to This Policy</Heading>
        <Paragraph>
          We may update this Privacy Policy from time to time. Continued use of the App after changes are made constitutes acceptance of the updated terms.
        </Paragraph>
      </Section>

      <Section>
        <Heading>11. Contact</Heading>
        <Paragraph>If you have any questions or concerns about this policy, please email: deeper@deepergm.com</Paragraph>
      </Section>
    </Box>
  );
};

export default PrivacyPolicyContent;
